import { c as _c } from "react/compiler-runtime";
import { numberConvert } from "@website/utils/number-convert";
export const AccommodationCardTitle = t0 => {
  const $ = _c(4);
  const {
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = numberConvert(title, {
      locale: "fa"
    });
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="accommodation-card-title text-subtitle-2 text-on-surface-high-emphasis mt-3 block min-w-0 truncate font-bold">{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};